import { LayoutHOC } from "base/ui/layout/layout";
import { createProductionActivities } from "./productionActivities";



export const createProductionActivitiesPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionActivities());
};